import { ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Heater } from '../types'
import { LoadingButton } from '@mui/lab'
import { updateHeater } from '../services/heater'
import { useDispatch } from 'react-redux'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'
import { useState } from 'react'
import { usePolicy } from '../hooks'

export interface HeaterDetachButtonProps extends Omit<ButtonProps, 'onClick'> {
  heater: Heater
  afterSubmit?: (heater: Heater) => void
}

export default function HeaterDetachButton({
  heater,
  afterSubmit,
  children,
  ...props
}: HeaterDetachButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('heater')

  /**
   * The policy state.
   */
  const { canEditHeater } = usePolicy()

  /**
   * The dispatch function.
   */
  const dispatch = useDispatch()

  /**
   * The submitting state.
   */
  const [isSubmitting, setSubmitting] = useState<boolean>(false)

  /**
   * Handle the submit action.
   */
  async function handleSubmit() {
    try {
      setSubmitting(true)

      const updatedHeater = await updateHeater(heater.id, {
        // FIXME: Providing "heatingPower" on update should be optional.
        heatingPower: heater.heatingPower,
        device: null
      })

      dispatch(createSuccessNotification(t('detachHeaterSuccess')))

      afterSubmit?.(updatedHeater)
    } catch (_) {
      dispatch(createErrorNotification(t('detachHeaterError')))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      {heater.deviceName !== null && canEditHeater(heater) && (
        <LoadingButton
          variant="contained"
          color="warning"
          {...props}
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {children ?? t('detachHeater')}
        </LoadingButton>
      )}
    </>
  )
}
